module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ted Scofield\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("TED SCOFIELD earned his BA, JD, and MBA at Vanderbilt University before beginning his career as a securities attorney. He now serves as the Chief Operating Officer and General Counsel of Icebreaker Entertainment. Scofield lives in Manhattan with his wife, Christi. "), _c('I', [_vm._v("Eat What You Kill ")]), _vm._v("is his first novel.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10m4rPD/tc-custom/9781250021816.jpg?1721404830055",
      "alt": "This image is the cover for the book Eat What You Kill"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eat What You Kill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In "), _c('i', [_vm._v("Eat What You Kill ")]), _vm._v("by Ted Scofield, Evan Stoess is a struggling young Wall Street analyst obsessed with fortune and fame. A trailer park kid who attended an exclusive prep school through a lucky twist of fate, Evan's unusual past leaves him an alien in both worlds, an outsider who desperately wants to belong. When a small stock he discovers becomes an overnight sensation, he is poised to make millions and land the girl of his dreams, but disaster strikes and he loses everything. "), _c('br'), _vm._v("Two years later a mysterious firm offers Evan a chance for redemption, and he jumps at the opportunity. His new job is to short stocks—to bet against the market. But when the stock goes up and he finds himself on the brink of ruin once again, another option presents itself: murder. At a moral crossroads, Evan must ask himself—how far will a man go for money and vengeance?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0